import React from 'react'
import Image1 from '../assets/about_1.png'
import Image2 from '../assets/about_2.png'
import { Helmet } from 'react-helmet'

const AboutUs = () => {
    return (
        <div className='py-[30px] md:py-[100px] px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%] flex flex-col gap-10 md:gap-[100px]'>
            <Helmet>
                <title>About Us - Supreme Nutra Shop</title>
                <meta name="description" content="This is a detailed description of the page content for better SEO" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="My SEO Optimized Page" />
                <meta property="og:description" content="This is a detailed description of the page content for better SEO" />
                <meta property="og:image" content="https://www.example.com/image.jpg" />
                <link rel="canonical" href="https://www.example.com/page" />
            </Helmet>
            <div className='flex items-center flex-col md:flex-row justify-center gap-y-4 gap-x-[88px]'>
                <div className='md:w-[50%] text-start'>
                    <div className='text-[clamp(1.5rem,4vw,2.5rem)] font-[600] leading-[clamp(2rem,5vw,3.125rem)]'>
                        <span className='text-black'>Our </span>
                        <span className='text-primary'>Mission</span>
                    </div>
                    <p className='text-secondary text-[clamp(0.8rem,4vw,1rem)] font-normal leading-[26px] mt-4'>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim  sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    </p>
                </div>
                <img src={Image1} alt="About_Image" className='md:w-[50%]' />
            </div>
            <div className='flex text-start md:text-center flex-col md:justify-center items-center'>
                <div className='text-[clamp(1.5rem,4vw,2.5rem)] font-[600] leading-[clamp(2rem,5vw,3.125rem)]'>
                    <span className='text-black'>Studied. tested. </span>
                    <span className='text-primary'>proven. essential.</span>
                </div>
                <p className='text-secondary text-[clamp(0.8rem,4vw,1rem)] font-normal leading-[26px] mt-4 max-w-[769px]'>
                    Safe, effective ingredients and full transparency; because when it comes to your health, the supplements you take should never be a mystery.
                </p>
            </div>
            <div className='flex items-center flex-col md:flex-row justify-center gap-y-4 gap-x-[88px]'>
                <img src={Image2} alt="About_Image" className='md:w-[50%]' />
                <div className='md:w-[50%] text-start'>
                    <div className='text-[clamp(1.5rem,4vw,2.5rem)] font-[600] leading-[clamp(2rem,5vw,3.125rem)]'>
                        <span className='text-black'>Our World </span>
                        <span className='text-primary'>Hydration Pledge</span>
                    </div>
                    <p className='text-secondary text-[clamp(0.8rem,4vw,1rem)] font-normal leading-[26px] mt-4'>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim  sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    </p>
                </div>

            </div>
        </div>
    )
}

export default AboutUs